export default __webpack_public_path__ + "bml-characteristic1.1d1ec45.png";